import { useTour } from "@reactour/tour";
import css from "./TutorialPopover.module.css";
import { RxCross2 } from "react-icons/rx";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectFinishedPages,
  selectTutorialNavigation,
  selectTutorialPage,
} from "../../../../redux/settings/selectors";
import { stringify } from "qs";
import { useDispatch } from "react-redux";
import {
  setFinishedPages,
  setIsServiceAccordionExpanded,
  setIsTutorialOpen,
  setTutorialSection,
} from "../../../../redux/settings/slice";
import { useLocation, useNavigate } from "react-router-dom";
import { PART_TO_PAGE } from "../../../../utils/PART_TO_PAGE";
import {
  selectChosenPartsInDiag,
  selectGlobalOfferObj,
  selectNewPartInRepair,
} from "../../../../redux/accounting/selectors";
import {
  setIsAddingNewRow,
  setModalCarId,
} from "../../../../redux/accounting/slice";

export default function TutorialPopover({
  title,
  content,
  disabledNext,
  disabledBack,
  currentBackStep,
  skipPart,
  modalStep,
}) {
  const { currentStep, steps, setCurrentStep, setIsOpen, setSteps } = useTour();
  const tutorialNavigation = useSelector(selectTutorialNavigation);
  const part = useSelector(selectTutorialPage);
  const savedFinishedPages =
    JSON.parse(localStorage.getItem("finishedPages") || "[]") || [];
  const [localFinishedPages, setLocalFinishedPages] =
    useState(savedFinishedPages);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const page = tutorialNavigation?.find(
    i => `/${i.name}` === location?.pathname
  );
  const pageParts = page?.sections;
  const currentSectionIndex = pageParts?.findIndex(i => i?.id === part);
  const chosenPartsInDiag = useSelector(selectChosenPartsInDiag);
  const globalOfferObj = useSelector(selectGlobalOfferObj);
  const newPart = useSelector(selectNewPartInRepair);

  console.log("New part", newPart);

  const disabledStepInCO =
    part === "co-modal" &&
    currentStep === 8 &&
    (!globalOfferObj?.[0]?.quantity ||
      !globalOfferObj?.[0]?.name ||
      !globalOfferObj?.[0]?.price ||
      !globalOfferObj?.[0]?.margin_price);

  const disabledStepInRepair =
    part === "repair-modal" &&
    currentStep === 7 &&
    (!newPart ||
      Object.keys(newPart).length === 0 ||
      Object.values(newPart).some(
        v => v === null || v === undefined || v === ""
      ));
  // useEffect(() => {
  //   localStorage.removeItem("finishedPages");
  // }, []);

  useEffect(() => {
    localStorage.setItem(
      "finishedPages",
      JSON.stringify(localFinishedPages ?? [])
    );
    dispatch(setFinishedPages(localFinishedPages));
  }, [localFinishedPages]);

  const disabledStepInDiagModal =
    part === "diag-modal" &&
    currentStep === 16 &&
    chosenPartsInDiag?.length === 0;
  console.log("currentStep", currentStep);

  const shouldReset =
    (currentStep === 9 && part === "prepayment-modal") ||
    (currentStep === 21 && part === "co-modal") ||
    (currentStep === 24 && part === "diag-modal") ||
    (currentStep === 9 && part === "client-payment-modal") ||
    (currentStep === 11 && part === "order-modal") ||
    (currentStep === 14 && part === "received-modal") ||
    (currentStep === 18 && part === "repair-modal");

  return (
    <div className={css.tutorialWrapper}>
      <RxCross2
        className={css.closeIcon}
        onClick={() => {
          if (location?.pathname === "/accounting/clients") {
            dispatch(setModalCarId(null));
          }
          setIsOpen(false);
          dispatch(setIsTutorialOpen(false));
          setCurrentStep(0);
        }}
      />
      <div className={css.contentBox}>
        <p className={css.title}>{title}</p>
        <p className={css.content}>{content}</p>
      </div>
      {/* кнопки */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* */}

        {modalStep ? (
          <div className={css.btnSkip}></div>
        ) : (
          <button
            className={css.btnSkip}
            onClick={() => {
              if (location?.pathname === "/accounting/clients") {
                dispatch(setModalCarId(null));
              }
              setCurrentStep(0);
              if (currentSectionIndex < pageParts?.length - 1) {
                setIsOpen(false);
                dispatch(
                  setTutorialSection(pageParts[currentSectionIndex + 1]?.id)
                );
                navigate(`${page?.name}`, {
                  state: { openTutorial: true },
                });
              } else {
                setIsOpen(false);
                dispatch(setIsTutorialOpen(false));
              }
              // setSteps([]);
            }}
          >
            Пропустити
          </button>
        )}

        <p className={css.quantity}>
          {currentStep + 1} з {steps?.length}
        </p>

        <div className={css.btnBox}>
          <button
            className={`${disabledBack && css.stepBtnDisabled} ${
              css.nextStepBtn
            }`}
            onClick={() => {
              if (part === "repair-modal" && currentStep === 6) {
                dispatch(setIsAddingNewRow(false));
              }

              if (currentStep === 0) {
                setIsOpen(false);
                dispatch(
                  setTutorialSection(pageParts[currentSectionIndex - 1]?.id)
                );

                navigate(`${page?.name}`, {
                  state: { openTutorial: true },
                });

                // setCurrentStep(0);
              }
              setCurrentStep(
                skipPart ? Number(currentBackStep) : currentStep - 1
              );
            }}
            // disabled={
            //   currentStep === 0 || currentStep === 4 || currentStep === 5
            // }
            disabled={disabledBack}
          >
            Назад
          </button>

          {/* {currentStep === 0 || currentStep === 4 || currentStep === 5 ? (
            // ||
            // currentStep === 8
            ""
          ) : */}
          {currentStep < steps?.length - 1 ? (
            <button
              className={`${css.nextStepBtn} ${
                disabledNext ||
                disabledStepInDiagModal ||
                disabledStepInCO ||
                disabledStepInRepair
                  ? css.stepBtnDisabled
                  : ""
              }`}
              onClick={() => {
                if (shouldReset) {
                  dispatch(setModalCarId(null));
                }
                setCurrentStep(currentStep + 1);
              }}
              disabled={
                disabledNext ||
                disabledStepInDiagModal ||
                disabledStepInCO ||
                disabledStepInRepair
              }
            >
              Далі
            </button>
          ) : (
            <button
              className={css.nextStepBtn}
              onClick={() => {
                // setIsOpen(false);
                // e.stopPropagation();
                if (part === "clientInfo-modal") {
                  dispatch(setModalCarId(null));
                }

                if (part === "schedule") {
                  dispatch(setIsServiceAccordionExpanded(false));
                }

                setLocalFinishedPages(prev => {
                  if (prev.includes(part)) {
                    // console.log("prev.includes(part)", prev.includes(part));

                    return prev;
                  }
                  return [...prev, part];
                });

                if (currentSectionIndex < pageParts?.length - 1) {
                  dispatch(
                    setTutorialSection(pageParts[currentSectionIndex + 1]?.id)
                  );
                  navigate(`${page?.name}`, {
                    state: { openTutorial: true },
                  });

                  setTimeout(() => {
                    setIsOpen(false);
                    setCurrentStep(0);
                  }, 100);
                } else {
                  setTimeout(() => {
                    dispatch(setIsTutorialOpen(false));

                    setIsOpen(false);
                  }, 100);
                }
              }}
            >
              Готово
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
